<template>
  <div style="width:95%;margin:0 auto">
    <div class="body">
      <h3 class="header">{{title}}</h3>
      <div class="title">{{user_count}}人参选,共提交{{count}}个选项.</div>
      <div v-for="(item,index) in list" :key="index">
        <h5>
          {{item.id}}.{{item.item}}
          <span style="color:red" v-if="item.list">已选{{item.list.length}}人</span>
        </h5>
        <div v-if="item.list">
          <div
            v-for="(people,index) in item.list"
            :key="index"
            style="display:flex;background-color:#ffffff;height:42px;line-height:42px;border-bottom:1px solid rgba(214, 207, 207, 0.733);"
          >
            <div style="flex:1">{{people.name}}</div>
            <div style="flex:1">{{people.branch}}</div>
            <div style="flex:1">{{people.dep}}</div>
          </div>
        </div>
        <div
          v-else
          style="background-color:#fff;height:40px;line-height:40px;border-bottom:1px solid rgba(214, 207, 207, 0.733);color:gray;text-align:center;"
        >未报名</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      count: "",
      title: "",
      user_count: ""
    };
  },
  methods: {},
  created() {
    if (this.$route.query.id) {
      this.$http
        .get("/oa/wxzhuzi/multi_answer?id=" + this.$route.query.id)

        .then(res => {
          this.title = res.data.data.title;
          this.count = res.data.data.count;
          this.user_count = res.data.data.user_count;
          this.list = res.data.data.list;
        });
    } else {
      this.$http.get("/oa/wxzhuzi/multi_answer?id=" + 2).then(res => {
        this.title = res.data.data.title;
        this.count = res.data.data.count;
        this.list = res.data.data.list;
        this.user_count = res.data.data.user_count;
      });
    }
  }
};
</script>

<style scoped>
.title {
  width: 90%;
  margin: 10px;
  font-size: 12px;
  color: gray;
}
.header {
  width: 100%;
  text-align: center;
  margin: 10px 0 0 0;
}
.body {
  background: #fafafa;
}
</style>



// WEBPACK FOOTER //
// src/views/multiadmin.vue